<ng-container>
  <p>All unsaved information will be lost</p>

  <iris-button-container [alignment]="irisButtonContainerAlignments.END">
    <iris-button (click)="close()" [buttonType]="irisButtonTypes.SECONDARY">
      Keep editing
    </iris-button>
    <iris-button (click)="closeWithoutSaving()">
      Leave without saving
    </iris-button>
  </iris-button-container>
</ng-container>